import * as React from 'react';

import 'react-phone-number-input/style.css';
import { StyledPhoneInput } from './style.phone';
interface PhoneNumberProps {
  number: string;
  handlePhoneNumber: any;
  error: boolean;
}
export default function PhoneNumber({
  number,
  handlePhoneNumber,
  error,
}: PhoneNumberProps) {
  return (
    <StyledPhoneInput
      international
      defaultCountry="FR"
      placeholder="Enter phone number"
      value={number}
      format="national"
      limitMaxLength
      sx={{
        border: error ? '1px solid red' : '1px solid #ccc',
        borderRadius: '4px',
      }}
      onChange={handlePhoneNumber}
    />
  );
}
